"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATION_MODE = exports.MemberImportValidator = void 0;
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _toConsumableArray2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find");
var _classCallCheck2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _checkExt = require("./check-ext");
var _validate = require("./validate");
/**
 * 内部名を使用した会員データの型定義。
 * mapToInternal() によって変換済みのデータを受け取る。
 *
 * @typedef {Object} InternalMember
 * @property {string|number} memberId
 * @property {string|number} password
 * @property {string} fullName
 * @property {string} fullNameFurigana
 * @property {string} [position]
 * @property {string} companyName
 * @property {string} companyNameFurigana
 * @property {string|number} industryCode
 * @property {string|number} phoneNumber
 * @property {string|number} [mobilePhone]
 * @property {string|number} [fax]
 * @property {string} [email]
 * @property {string} [website]
 * @property {string|number} postcode
 * @property {string} address1
 * @property {string} [address2]
 * @property {string} [businessDescriptions]
 * @property {string|number} [capitalStock]
 * @property {string|number} [employees]
 * @property {string|number} [employeesPartTime]
 * @property {string|Date} joinDate
 * @property {string|Date} [established]
 * @property {string|Date} [birthday]
 * @property {string|number} affiliationId
 */

var VALIDATION_MODE = exports.VALIDATION_MODE = {
  NEW_USER: 'new',
  EXISTING_USER: 'existing'
};
var MemberImportValidator = exports.MemberImportValidator = /*#__PURE__*/function () {
  /**
   * @param {Object} options
   * @param {Array} options.industries - 業種マスタ
   * @param {Array} options.affiliations - 所属ツリー
   * @param {Object} [options.format] - フォーマット定義（ラベル解決用）
   */
  function MemberImportValidator(_ref) {
    var industries = _ref.industries,
      affiliations = _ref.affiliations,
      format = _ref.format;
    (0, _classCallCheck2.default)(this, MemberImportValidator);
    this.industries = industries;
    this.affiliations = affiliations;
    this.format = format || null;
  }

  /**
   * 内部名からラベルを取得する。
   * @param {string} internalName
   * @returns {string}
   */
  return (0, _createClass2.default)(MemberImportValidator, [{
    key: "_label",
    value: function _label(internalName) {
      if (this.format) {
        var f = this.format.fields.find(function (field) {
          return field.internalName === internalName;
        });
        if (f) return f.label;
      }
      return internalName;
    }

    /**
     * 会員データのバリデーションを行う。
     * member オブジェクトを in-place で正規化する（空白→null、日付フォーマット、業種コード変換）。
     *
     * @param {InternalMember} member - 内部名形式の1行分のデータ
     * @param {string} mode - VALIDATION_MODE.NEW_USER または VALIDATION_MODE.EXISTING_USER
     * @returns {{ status: boolean, message: string }}
     */
  }, {
    key: "validate",
    value: function validate(member) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : VALIDATION_MODE.NEW_USER;
      var isNew = mode === VALIDATION_MODE.NEW_USER;

      // 空白のみの値をundefinedに正規化
      Object.keys(member).forEach(function (key) {
        if (typeof member[key] === 'string' && member[key].trim() === '') {
          member[key] = undefined;
        }
      });

      // 入会年（新規: 必須、既存: 任意）
      if (this._requireField(member, 'joinDate', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('joinDate') + '」が未入力の箇所があります。'
        };
      }
      if (member.joinDate != null) {
        var joinDateErr = this._validateDateField(member, 'joinDate', this._label('joinDate'), {
          minYear: 1950
        });
        if (joinDateErr) return joinDateErr;
      }

      // 所属_ID（常に必須）
      if (typeof member.affiliationId === 'undefined') {
        return {
          status: false,
          message: '「' + this._label('affiliationId') + '」が未入力の箇所があります。'
        };
      }

      // 会社名（新規: 必須、既存: 任意）
      if (this._requireField(member, 'companyName', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('companyName') + '」が未入力の箇所があります。'
        };
      }

      // 会社名_ふりがな（新規: 必須、既存: 任意）
      if (this._requireField(member, 'companyNameFurigana', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('companyNameFurigana') + '」が未入力の箇所があります。'
        };
      }

      // 会員名（新規: 必須、既存: 任意）
      if (this._requireField(member, 'fullName', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('fullName') + '」が未入力の箇所があります。'
        };
      }

      // 会員名_ふりがな（新規: 必須、既存: 任意）
      if (this._requireField(member, 'fullNameFurigana', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('fullNameFurigana') + '」が未入力の箇所があります。'
        };
      }

      // 役職名（任意）
      if (typeof member.position === 'undefined') {
        member.position = null;
      }

      // 郵便番号（新規: 必須、既存: 任意）
      if (this._requireField(member, 'postcode', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('postcode') + '」が未入力の箇所があります。'
        };
      }
      if (member.postcode != null) {
        var zipcodeStr = member.postcode.toString().trim();
        if (zipcodeStr !== '' && zipcodeStr !== 'null') {
          var zipcode = MemberImportValidator.zenkaku2hankaku(String(member.postcode).trim()).replace('−', '-').split('-');
          if (zipcode.length !== 2) {
            return {
              status: false,
              message: '「' + this._label('postcode') + '」のフォーマット（区切りコード"-"の数）が正しくない箇所があります。'
            };
          }
          if (MemberImportValidator.isNumber(zipcode[0]) === false || MemberImportValidator.isNumber(zipcode[1]) === false) {
            return {
              status: false,
              message: '「' + this._label('postcode') + '」のフォーマット（不正なコードの存在）が正しくない箇所があります。'
            };
          }
          if (zipcode[0].length !== 3) {
            return {
              status: false,
              message: '「' + this._label('postcode') + '」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }
          if (zipcode[1].length !== 4) {
            return {
              status: false,
              message: '「' + this._label('postcode') + '」のフォーマットが正しくない箇所があります。'
            };
          }
        }
      }

      // 会社所在地（新規: 必須、既存: 任意）
      if (this._requireField(member, 'address1', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('address1') + '」が未入力の箇所があります。'
        };
      }

      // ビル名（任意）
      if (typeof member.address2 === 'undefined') {
        member.address2 = null;
      }

      // 電話番号（新規: 必須、既存: 任意）
      if (this._requireField(member, 'phoneNumber', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('phoneNumber') + '」が未入力の箇所があります。'
        };
      }
      if (member.phoneNumber != null) {
        var phoneErr = this._validatePhoneFormat(member.phoneNumber, this._label('phoneNumber'));
        if (phoneErr) return phoneErr;
      }

      // 携帯電話（任意）
      if (typeof member.mobilePhone === 'undefined') {
        member.mobilePhone = null;
      } else if (member.mobilePhone && member.mobilePhone.toString().trim() && member.mobilePhone !== 'null') {
        var mobileErr = this._validatePhoneFormat(member.mobilePhone, this._label('mobilePhone'));
        if (mobileErr) return mobileErr;
      }

      // FAX（任意）
      if (typeof member.fax === 'undefined') {
        member.fax = null;
      } else if (member.fax && member.fax !== 'null') {
        var faxErr = this._validatePhoneFormat(member.fax, this._label('fax'));
        if (faxErr) return faxErr;
      }

      // Email（任意）
      if (typeof member.email === 'undefined') {
        member.email = null;
      }

      // ホームページ（任意）
      if (typeof member.website === 'undefined') {
        member.website = null;
      }

      // 業種コード（新規: 必須、既存: 任意）
      if (this._requireField(member, 'industryCode', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('industryCode') + '」が未入力の箇所があります。'
        };
      }
      if (member.industryCode != null) {
        var industryErr = this._validateIndustryCode(member);
        if (industryErr) return industryErr;
      }

      // 事業内容（新規: 必須、既存: 任意）
      if (this._requireField(member, 'businessDescriptions', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('businessDescriptions') + '」が未入力の箇所があります。'
        };
      }

      // 設立年月日（任意）
      var estErr = this._validateDateField(member, 'established', this._label('established'), {
        minYear: 1880
      });
      if (estErr) return estErr;

      // 生年月日（任意、YYYY-MM-DD 完全日付のみ）
      var bdErr = this._validateDateField(member, 'birthday', this._label('birthday'), {
        requireFullDate: true
      });
      if (bdErr) return bdErr;
      if (member.birthday != null) {
        if ((0, _validate.year_month_day)(member.birthday) > (0, _validate.year_month_day)(new Date())) {
          return {
            status: false,
            message: '「' + this._label('birthday') + '」は未来の日付で登録できません。'
          };
        }
      }

      // 資本金（任意）
      if (typeof member.capitalStock === 'undefined') {
        member.capitalStock = null;
      }

      // 社員数（任意）
      if (typeof member.employees === 'undefined') {
        member.employees = null;
      }

      // パート_アルバイト数（任意）
      if (typeof member.employeesPartTime === 'undefined') {
        member.employeesPartTime = null;
      }

      // 会員ID（常に必須）
      if (typeof member.memberId === 'undefined') {
        return {
          status: false,
          message: '「' + this._label('memberId') + '」が未入力の箇所があります。'
        };
      }
      member.memberId = String(member.memberId);
      if (MemberImportValidator.isHanEisu(String(member.memberId)) === false) {
        return {
          status: false,
          message: '「' + this._label('memberId') + '」は半角英数字で入力してください。'
        };
      }
      if (member.memberId.length < 3) {
        return {
          status: false,
          message: '「' + this._label('memberId') + '」は3文字以上で入力してください。'
        };
      }

      // 会員パスワード（新規: 必須、既存: 任意）
      if (this._requireField(member, 'password', isNew) === false) {
        return {
          status: false,
          message: '「' + this._label('password') + '」が未入力の箇所があります。'
        };
      }
      if (member.password != null) {
        member.password = String(member.password);
        if (MemberImportValidator.isHanEisu(String(member.password)) === false) {
          return {
            status: false,
            message: '「' + this._label('password') + '」は半角英数字で入力してください。'
          };
        }
        if (member.password.length < 4) {
          return {
            status: false,
            message: '「' + this._label('password') + '」は４文字以上で入力してください。'
          };
        }
        if (member.password.length > 8) {
          return {
            status: false,
            message: '「' + this._label('password') + '」は８文字以下で入力してください。'
          };
        }
      }
      return {
        status: true,
        message: 'SUCCESS'
      };
    }

    /**
     * 所属IDの存在チェックを行う。
     *
     * @param {InternalMember} member
     * @returns {string|false} エラーメッセージ、または問題なければ false
     */
  }, {
    key: "validateAffiliationIds",
    value: function validateAffiliationIds(member) {
      var inputMember = member.affiliationId;
      var checkNumberComma = (0, _checkExt.checkIsNumberAndComma)(inputMember);
      if (checkNumberComma === false) return '所属IDをご確認ください。';
      var setMember = (0, _toConsumableArray2.default)(new Set(inputMember.toString().split(','))).filter(function (item) {
        return item.toString().trim() !== '';
      });
      if (setMember.length === 0) return '所属IDのフォーマットが正しくない箇所があります。';
      var affiliations = this.affiliations;
      var entireOrganizationId = [];
      var objectAffiliation = [];
      if (affiliations.length === 0) return 'データに失敗しました。 ';
      function affliationSelect(aff) {
        if (setMember.filter(function (item) {
          return item.toString().trim() === aff.id.toString();
        }).length !== 0) objectAffiliation.push(aff);
        entireOrganizationId.push(aff.id.toString());
        if (aff.affiliations) return aff.affiliations.forEach(function (i) {
          return affliationSelect(i);
        });
      }
      if (affiliations) affiliations.forEach(function (item) {
        return affliationSelect(item);
      });
      var setAff = setMember.filter(function (member) {
        return (0, _toConsumableArray2.default)(new Set(entireOrganizationId)).some(function (entire) {
          return member.toString().trim() === entire.toString().trim();
        }) === false;
      });
      if (setAff.length !== 0) return '所属IDに該当するIDがありません。';else return false;
    }

    // --- Private helpers ---
  }, {
    key: "_requireField",
    value: function _requireField(member, fieldName, isNew) {
      if (typeof member[fieldName] === 'undefined') {
        if (isNew) {
          return false; // caller returns error
        }
        member[fieldName] = null;
        return null; // skip
      }
      return true; // has value
    }
  }, {
    key: "_validatePhoneFormat",
    value: function _validatePhoneFormat(value, label) {
      var str = value.toString().trim();
      if (str === '' || str === 'null') return null;
      var parts = MemberImportValidator.zenkaku2hankaku(String(value).trim()).replace('−', '-').replace('−', '-').split('-');
      if (parts.length !== 3) {
        return {
          status: false,
          message: '「' + label + '」のフォーマット（区切りコード"-"の数）が正しくない箇所があります。'
        };
      }
      for (var i = 0; i < 3; i++) {
        if (MemberImportValidator.isNumber(parts[i]) === false) {
          return {
            status: false,
            message: '「' + label + '」のフォーマット（不正なコードの存在）が正しくない箇所があります。'
          };
        }
        if (parts[i].length < 1 || parts[i].length > 5) {
          return {
            status: false,
            message: '「' + label + '」のフォーマット（桁数）が正しくない箇所があります。'
          };
        }
      }
      return null;
    }

    // 日付フィールドのバリデーションと正規化を行う。
    // requireFullDate=false: 年のみ(YYYY)、年月(YYYY-MM)、年月日(YYYY-MM-DD) を許容（join_date, established 用）
    // requireFullDate=true: 年月日(YYYY-MM-DD) のみ許容（birthday 用）
  }, {
    key: "_validateDateField",
    value: function _validateDateField(member, fieldName, label) {
      var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$requireFullDate = _ref2.requireFullDate,
        requireFullDate = _ref2$requireFullDate === void 0 ? false : _ref2$requireFullDate,
        minYear = _ref2.minYear;
      if (typeof member[fieldName] === 'undefined') {
        member[fieldName] = null;
      } else if (member[fieldName]) {
        var errMsg = '「' + label + '」のフォーマットを確認してください。';
        if (member[fieldName] instanceof Date) {
          var d = member[fieldName];
          member[fieldName] = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
        }
        var raw = member[fieldName].toString().trim();
        var parts = raw.split(/[/\-]/);
        if (parts.length < 1 || parts.length > 3) {
          return {
            status: false,
            message: errMsg
          };
        }
        if (requireFullDate && parts.length !== 3) {
          return {
            status: false,
            message: errMsg
          };
        }
        var year = parts[0];
        var month = parts[1];
        var day = parts[2];
        if (!/^\d{4}$/.test(year)) {
          return {
            status: false,
            message: errMsg
          };
        }
        if (minYear && Number(year) < minYear) {
          return {
            status: false,
            message: '「' + label + '」は' + minYear + '年以降の日付で入力してください。'
          };
        }
        if (month != null) {
          if (!/^\d{1,2}$/.test(month) || Number(month) < 1 || Number(month) > 12) {
            return {
              status: false,
              message: errMsg
            };
          }
        }
        if (day != null) {
          if (!month) {
            return {
              status: false,
              message: errMsg
            };
          }
          var maxDay = new Date(Number(year), Number(month), 0).getDate();
          if (!/^\d{1,2}$/.test(day) || Number(day) < 1 || Number(day) > maxDay) {
            return {
              status: false,
              message: errMsg
            };
          }
        }
        if (parts.length === 1) {
          member[fieldName] = year;
        } else if (parts.length === 2) {
          member[fieldName] = year + '-' + ('0' + Number(month)).slice(-2);
        } else {
          member[fieldName] = year + '-' + ('0' + Number(month)).slice(-2) + '-' + ('0' + Number(day)).slice(-2);
        }
      }
      return null;
    }
  }, {
    key: "_validateIndustryCode",
    value: function _validateIndustryCode(member) {
      var in_hit = this.industries.some(function (item) {
        return Number(item.code) === Number(member.industryCode);
      });
      if (in_hit === false) {
        if (member.industryCode.toString().trim() === '0' || member.industryCode.toString().trim() === '' || member.industryCode.toString().trim() === 'null') {
          member.industryCode = '01';
        } else {
          return {
            status: false,
            message: '「' + this._label('industryCode') + '(' + member.industryCode + ')」は存在しません。'
          };
        }
      }
      member.industryCode = ('00' + Number(member.industryCode)).slice(-2);
      return null;
    }

    // --- Static utility methods ---
  }], [{
    key: "zenkaku2hankaku",
    value: function zenkaku2hankaku(val) {
      var regex = /[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g;
      var value = val.replace(regex, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      }).replace(/[‐－―]/g, '-').replace(/[～〜]/g, '~').replace(/u{3000}/g, ' ');
      return value;
    }
  }, {
    key: "isNumber",
    value: function isNumber(val) {
      var regex = new RegExp(/^[0-9]+$/);
      return regex.test(val);
    }
  }, {
    key: "isHanEisu",
    value: function isHanEisu(str) {
      str = str === null ? '' : str;
      if (str.match(/^[A-Za-z0-9]*$/)) {
        return true;
      } else {
        return false;
      }
    }
  }]);
}();